var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtCHov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2254 90.4229C66.4087 103.417 50.1477 114.957 33.6694 98.2524C25.0035 89.4674 10.1492 66.3305 9.79396 47.3237C5.66153 31.1082 21.4992 19.6766 29.23 12.1188C45.5359 -3.82245 66.0852 12.1412 82.5635 28.8461C99.0418 45.5509 101.531 74.4816 85.2254 90.4229Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3029 71.8748C21.3115 69.3349 26.7528 65.017 32.4498 68.0649C39.571 71.8748 40.1188 79.4945 37.9277 83.3044C35.7365 87.1143 26.9719 90.38 22.0418 86.0258C18.0978 82.5424 17.722 79.5951 18.0872 77.418",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7174 69.0199C79.6815 69.2271 77.2816 75.2234 76.8361 78.1957L77.4683 81.3249C78.1857 83.2412 80.8251 87.3132 85.6431 88.2712C91.6655 89.4688 97.2486 82.7696 97.2509 78.6936C97.2531 74.6177 93.2623 68.7609 85.7174 69.0199Z",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2279 77.5599C9.9915 77.2404 5.51871 75.8346 5.51871 72.7676C5.51871 68.9338 3.6018 33.4709 5.51871 30.5956C7.43562 27.7202 9.35253 24.8448 12.2279 24.8448C15.1033 24.8448 61.4704 21.9695 65.3043 24.8448C69.1381 27.7202 67.2212 36.3462 71.055 36.3462C74.8888 36.3462 87.9458 35.3878 89.8627 38.2631C91.7796 41.1385 102.323 55.5153 105.198 59.3491C108.073 63.183 106.156 74.6845 103.281 75.6429",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5595 45.1108C84.2199 45.1108 77.4352 45.1108 77.0134 45.1108C76.4861 45.1108 74.9041 51.9873 78.5953 52.6125C81.5482 53.1126 88.6141 52.8209 91.778 52.6125",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4446 32.6665L71.5557 71.5554",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47705 59.3491L42.8983 59.3491",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7322 78.5184C53.0778 77.0719 64.9428 76.6014 69.7351 78.5184",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H112V112H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtCHov);
export default __webpack_public_path__ + "static/media/vt_c_hov.061ebf109ab51566c5ce32272885694b.svg";
export { ForwardRef as ReactComponent };